import useHasMounted from '@/hooks/useHasMounted';

export default function DateComponent({ date }: { date: string | Date }) {
  const hasMounted = useHasMounted();

  if (hasMounted) {
    if (date instanceof Date) {
      return date.toLocaleDateString();
    } else {
      return new Date(date).toLocaleDateString();
    }
  }

  return null;
}
